import { ProgressOrderStatus } from './types/orders';

export type ProgressOrderStatusBannerMeta = {
    text: string;
    label: string;
    severity: 'error' | 'info' | 'success' | 'warning';
    color: 'default' | 'error' | 'info' | 'primary' | 'secondary' | 'success' | 'warning';
};

export const progressOrderStatusBanners: Record<ProgressOrderStatus, ProgressOrderStatusBannerMeta> = {
    [ProgressOrderStatus.CREATING_DELIVERY_ORDER]: {
        text: 'Заказ создается в транспортной компании.',
        label: 'Создание заказа доставки',
        severity: 'info',
        color: 'warning'
    },
    [ProgressOrderStatus.DELIVERY_ORDER_IS_INVALID]: {
        text: 'Невозможно создать заказ в системе ТК. Нужно смотреть логи по какой причине не удается создать заказ в ТК.',
        label: 'Фатальная ошибка создания заказа',
        severity: 'error',
        color: 'error'
    },
    [ProgressOrderStatus.ERROR_WHEN_CREATING_DELIVERY_ORDER]: {
        text: 'Не удалось создать заказ в ТК. Продавцу нужно повторно нажать кнопку создания заказа.',
        label: 'Ошибка при создании заказа доставки',
        severity: 'error',
        color: 'error'
    },
    [ProgressOrderStatus.WAITING_FOR_SHIPMENT]: {
        text: 'Заказ ожидает отправки продавцом',
        label: 'Ожидание отправки',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.DELIVERY_EXPIRED]: {
        text: 'Продавец не успел отнести заказ в доставку и поэтому заказ отменен нашей системой.',
        label: 'Доставка истекла',
        severity: 'warning',
        color: 'warning'
    },
    [ProgressOrderStatus.CANCELLED_BEFORE_DELIVERY_BY_SELLER]: {
        text: 'Продавец отменил заказ до доставки.',
        label: 'Отменен продавцом до доставки',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.CANCELLED_BEFORE_DELIVERY_BY_CUSTOMER]: {
        text: 'Покупатель отменил заказ до доставки.',
        label: 'Отменен покупателем до доставки',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.CANCELLED_IN_DELIVERY_BY_CUSTOMER]: {
        text: 'Покупатель отменил заказ в доставке. В этом случае создается обратный заказ для продавца, чтобы получить заказ обратно.',
        label: 'Отменен покупателем во время доставки',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.CANCELLED_AFTER_DELIVERED_BY_CUSTOMER]: {
        text: 'Покупатель отказался от вещи в ПВЗ и она возвращается обратно продавцу. Должен создаться обратный заказ.',
        label: 'Отказ от получения',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.CANCELLED_BY_EXPIRED_PICKING]: {
        text: 'Покупатель не забрал заказ из ПВЗ и система инициировала отмену. Заказ возвращается обратно продавцу.',
        label: 'Отменен по истечении времени получения',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.ORDER_IS_RETURNING_TO_SELLER]: {
        text: 'Заказ уже в пути обратно к продавцу.',
        label: 'Возврат продавцу',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.ORDER_RETURNED_TO_SELLER_POINT]: {
        text: 'Заказ вернулся обратно продавцу в ПВЗ.',
        label: 'Возвращен в пункт продавца',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.IN_DELIVERY]: {
        text: 'Вещь в доставке до покупателя.',
        label: 'В доставке',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.IN_DELIVERY_POINT]: {
        text: 'Вещь пришла в ПВЗ, выбранный покупателем.',
        label: 'В пункте выдачи',
        severity: 'info',
        color: 'info'
    },
    [ProgressOrderStatus.RETURNED_ORDER_WAS_PICKED_BY_SELLER]: {
        text: 'Обратный заказ взят продавцом.',
        label: 'Возврат получен продавцом',
        severity: 'success',
        color: 'success'
    },
    [ProgressOrderStatus.RECEIVED]: {
        text: 'Заказ был взят покупателем.',
        label: 'Получен',
        severity: 'success',
        color: 'success'
    },
    [ProgressOrderStatus.REQUIRED_SENDER_INFORMATION]: {
        text: 'Требуются дополнительные данные отправителя для заказа.',
        label: 'Требуются данные',
        severity: 'info',
        color: 'info'
    }
};

export const getProgressOrderStatusMeta = (status?: string | null): ProgressOrderStatusBannerMeta | null => {
    if (typeof status !== 'string') {
        return null;
    }

    const normalizedStatus = status.trim();
    if (!normalizedStatus) {
        return null;
    }

    return (progressOrderStatusBanners as Record<string, ProgressOrderStatusBannerMeta>)[normalizedStatus] || null;
};
